(() => {
  const init = scope => {
    scope.querySelectorAll('.glass-calculator-block').forEach(root => {
      if (root.dataset.enhanced) return;
      root.dataset.enhanced = 'true';
      const status = root.querySelector('[data-calculator-status]');
      const fallback = root.querySelector('[data-calculator-fallback]');
      const refresh = () => {
        root.querySelectorAll('.optionHolder').forEach(holder => {
          const label = holder.querySelector('label.option-label');
          const input = holder.querySelector('input.option-number-input');
          if (!label || !input?.id) return;
          label.htmlFor = input.id;
          input.inputMode = input.dataset.decimals === '0' ? 'numeric' : 'decimal';
          input.setAttribute('aria-required', String(label.textContent.includes('*')));
          const error = document.getElementById('error-msg-' + input.id);
          const helpId = input.id + '-range-help';
          let hint = document.getElementById(helpId);
          if (!hint && input.hasAttribute('min') && input.hasAttribute('max')) {
            hint = document.createElement('p'); hint.id = helpId; hint.className = 'glass-field-range caption';
            hint.textContent = `${input.min}–${input.max}${/mm/i.test(label.textContent) ? " mm" : ""}`;
            input.parentElement.append(hint);
          }
          const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
          if (hint) describedBy.add(hint.id);
          if (error) {
            error.setAttribute('aria-live', 'polite');
            describedBy.add(error.id);
            input.setAttribute('aria-invalid', String(Boolean(error.textContent.trim())));
          }
          input.setAttribute('aria-describedby', [...describedBy].join(' '));
        });
        const button = root.querySelector('.addToCartCustomButton');
        if (button) { if (status) status.hidden = true; if (fallback) fallback.hidden = true; }
        const requiredNumbers = [...root.querySelectorAll('.option-number-input[aria-required="true"]')];
        const incomplete = requiredNumbers.some(input => !input.value.trim() || !Number.isFinite(Number(input.value.replace(',', '.'))) || (input.min !== '' && Number(input.value.replace(',', '.')) < Number(input.min)) || (input.max !== '' && Number(input.value.replace(',', '.')) > Number(input.max)));
        const price = root.querySelector('.option-price-container');
        const pricePrompt = root.querySelector('[data-price-prompt]');
        if (price) price.hidden = incomplete;
        if (pricePrompt) pricePrompt.hidden = !button || !incomplete;
        // Only hide the app's stale required-fields summary when the app itself permits purchase.
        const error = root.querySelector('.product-error-msg');
        if (error) {
          const generic = ['Formularen er ikke udfyldt rigtigt', 'Kontrollér de markerede felter og udfyld alle påkrævede oplysninger.'].includes(error.textContent.trim().replace(/^\*+\s*/, ''));
          const fieldErrors = [...root.querySelectorAll('.errorMsgCss')].some(node => node.textContent.trim());
          error.hidden = Boolean(generic && button && !button.disabled && !fieldErrors);
          error.setAttribute('role', 'alert');
        }
      };
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; refresh(); });
      });
      observer.observe(root, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled']});
      root.addEventListener('input', () => requestAnimationFrame(refresh));
      refresh();
      setTimeout(() => { if (!root.isConnected) { observer.disconnect(); return; } if (!root.querySelector('.addToCartCustomButton') && fallback) { fallback.hidden = false; if (status) status.hidden = true; } }, 15000);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
